// src/components/PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../utils/axiosConfig';
import PreLoader from '../Loader/PreLoader';

const PrivateRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null); // null = loading

  useEffect(() => {
    const checkToken = async () => {
      const token = sessionStorage.getItem('token');
      if (!token) {
        setIsValid(false);
        return;
      }
  
      try {
        const res = await api.get('/me'); // Get student info
        sessionStorage.setItem('student_name', res.data.student.student_name);
        sessionStorage.setItem('student_uid', res.data.student.student_uid);
        sessionStorage.setItem('student_photo_file', res.data.student.student_photo_file); // <-- Add this
        sessionStorage.setItem('current_date', res.data.currentDate); // <-- Add this
        sessionStorage.setItem('is_room_alloted', res.data.isRoomAllocated); // <-- Add this
        sessionStorage.setItem('batch_no', res.data.student.batch_no); // <-- Add this
        sessionStorage.setItem('academic_level', res.data.student.academic_level); // <-- Add this
        setIsValid(true);
      } catch {
        setIsValid(false);
      }
    };
  
    checkToken();
  }, []);

  if (isValid === null) return <PreLoader/>; // Optional loader
  return isValid ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
